import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "dropdown multi-select-vue",
  ref: "dropDownElement"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "dropdown-toggle ps-2" }, null, -1 /* HOISTED */)
const _hoisted_4 = {
  class: "dropdown-menu",
  ref: "dropDownMenu"
}
const _hoisted_5 = { class: "input-group p-1" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" })
  ])
], -1 /* HOISTED */)
const _hoisted_8 = {
  key: 0,
  class: "dropdown-item p-0 my-1"
}
const _hoisted_9 = { class: "form-check ps-2" }
const _hoisted_10 = { class: "form-check-label ms-2" }
const _hoisted_11 = ["checked"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Select All ")
const _hoisted_13 = {
  key: 1,
  class: "dropdown-divider"
}
const _hoisted_14 = { class: "content" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["for"]
const _hoisted_17 = { class: "form-check-label ms-2" }
const _hoisted_18 = ["id", "onChange", "checked"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* HOISTED */)
const _hoisted_20 = { class: "px-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass(`btn btn-light bg-white dropdown-border ps-2  ${_ctx.disabled ? 'disabled' : ''} ${_ctx.classes}`),
      type: "button",
      "data-bs-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false",
      disabled: _ctx.disabled
    }, [
      _createElementVNode("span", null, _toDisplayString(_ctx.getbuttonText), 1 /* TEXT */),
      _hoisted_3
    ], 10 /* CLASS, PROPS */, _hoisted_2),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control",
          ref: "searchInput",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
          placeholder: _ctx.getsearchPlaceholder
        }, null, 8 /* PROPS */, _hoisted_6), [
          [_vModelText, _ctx.search]
        ]),
        _hoisted_7
      ]),
      (!_ctx.search)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", _hoisted_10, [
                _createElementVNode("input", {
                  class: "form-check-input-sm",
                  type: "checkbox",
                  checked: _ctx.selectedOptions.length === _ctx.getdropDownOptionsLength,
                  onChange: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.toggleAllSelected()), ["prevent"]))
                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_11),
                _hoisted_12
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true),
      (!_ctx.search)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_14, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.filteredOptions), (groupName) => {
          return (_openBlock(), _createElementBlock("div", { key: groupName }, [
            (groupName && _ctx.filteredOptions[groupName].length > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-link border-0",
                  onClick: ($event: any) => (_ctx.toggleAllGroupOptions(groupName))
                }, _toDisplayString(groupName), 9 /* TEXT, PROPS */, _hoisted_15))
              : _createCommentVNode("v-if", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredOptions[groupName], (option) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "dropdown-item p-0 my-1",
                key: option.value
              }, [
                _createElementVNode("div", {
                  class: "form-check ps-2",
                  for: `option-${option}`
                }, [
                  _createElementVNode("label", _hoisted_17, [
                    _createElementVNode("input", {
                      class: "form-check-input-sm",
                      type: "checkbox",
                      id: `option-${option}`,
                      onChange: _withModifiers(($event: any) => (_ctx.toggleSingleSelection(option.value)), ["prevent"]),
                      checked: _ctx.selectedOptions.includes(option.value)
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_18),
                    _createTextVNode(" " + _toDisplayString(option.displayText), 1 /* TEXT */)
                  ])
                ], 8 /* PROPS */, _hoisted_16)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _hoisted_19,
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-xs btn-outline-dark w-100",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeDropDown()))
        }, "Close")
      ])
    ], 512 /* NEED_PATCH */)
  ], 512 /* NEED_PATCH */))
}